type Scheduler = {
	postTask: <T>(
		cb: () => T,
		options: {
			delay?: number;
			priority?: 'background' | 'user-blocking' | 'user-visible';
			signal?: AbortSignal;
		},
	) => Promise<T>;
};

type PostTask = Scheduler['postTask'];

async function toPromise<T>(callback: () => T) {
	return callback();
}

function getScheduler(obj: any): Scheduler | undefined {
	if ('scheduler' in obj && obj.scheduler !== 'undefined') {
		return obj.scheduler;
	}
}

// TODO Use the postTask type for the callback and return type once the current TypeScript version supports
//  forwarding the generic to the function (>=v4.7.4)
export function postTask<T>(callback: () => T, options: Parameters<PostTask>[1]): Promise<T> {
	// Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
	// do not pay the performance cost (e.g. bundle size, runtime, etc).
	const scheduler = getScheduler(globalThis);
	if (!scheduler) {
		// Only load the polyfill if we are using the background priority
		if (options.priority === 'background') {
			// This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
			// eslint-disable-next-line import/dynamic-import-chunkname
			// @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
			return import('scheduler-polyfill').then(() =>
				(getScheduler(globalThis) as Scheduler).postTask(callback, options),
			);
		}

		return toPromise<T>(callback);
	}

	return scheduler.postTask(callback, options);
}
